import { useLocation } from 'preact-iso';
import AuthenticatedPage from '../../components/authenticated-page';
import { Icon } from '../../components/icon';
import { Link } from '../../components/link';
import { usePodcastsStore } from '../../global-state/podcasts';
import { useUserDataStore } from '../../global-state/user-data';
import getThumbUrl from '../../utils/get-thumb';
import { usePageTitle } from '../../utils/page-title';
import { trackLibraryPodcastClick } from '../../utils/plausible-events';
import style from './style.module.scss';

export default function Library() {
  usePageTitle('Library');
  const followedPodcastIds = useUserDataStore((s) => s.followedPodcastIds);
  const podcasts = usePodcastsStore((store) => store.podcasts);
  const followedPodcasts = followedPodcastIds.map((id) => podcasts[id]).filter(Boolean);
  const { route } = useLocation();

  return (
    <AuthenticatedPage>
      <div class="top-section">
        {followedPodcasts.length ? (
          <>
            <h1 class="mb-2 text-xl">Followed Podcasts</h1>
            <div class={style.podcastGrid} style={{ marginBottom: '0.5rem' }}>
              {followedPodcasts.map((podcast) => {
                return (
                  <a
                    class={style.podcastCard}
                    href={`/podcast/${podcast.id}`}
                    onClick={() => trackLibraryPodcastClick(podcast)}
                  >
                    <img src={getThumbUrl(podcast, 150)} alt={podcast.name} />
                  </a>
                );
              })}
            </div>
            <br />
            <br />
            <div class="flex">
              <Link href="/downloads">
                <button class="button button--transparent">Downloads »</button>
              </Link>
            </div>
            <br />
            <div class="flex">
              <Link href="/history">
                <button class="button button--transparent">Listening History »</button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <h2 class={style.heading}>Select Podcasts</h2>
            <p>
              Search for podcasts and press the{' '}
              <button class="button button--favorite button--inline">
                <span>Follow</span>
                <Icon sprite="plus-circle" />
              </button>{' '}
              button to add them here. We'll keep track of these podcasts and let you
              know when there's new episodes!
            </p>
            <button
              class="button button--transparent"
              style={{
                '--button-height': '36px',
                fontSize: '16px',
                margin: '8px auto 0 0',
              }}
              onClick={() => route('/search')}
            >
              Search for Podcasts
            </button>
          </>
        )}
      </div>
    </AuthenticatedPage>
  );
}
